import isArray from 'lodash/isArray';

export const initialState = {
	list: {
		data: [],
		loading: true
	},
	listCredits: {
		data: [],
		loading: true
	},
	history: {
		data: [],
		loading: true
	},
	refundsHistory: {
		data: [],
		loading: true
	},
	refundsHistoryDetails: {
		data: [],
		loading: true
	},
	refundsHistoryPdf: {
		blob: null,
	}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case 'GET_TRANSACTION_LIST_REQUEST':
			return { ...state, list: { ...initialState.list } };

		case 'GET_TRANSACTION_LIST_SUCCESS': {
			if (action.payload && isArray(action.payload)) {
				const data = [...state.list.data, ...action.payload];
				return { ...state, list: { data, loading: false } };
			}
			return { ...state };
		}
		case 'GET_TRANSACTION_BY_USER_ID_REQUEST':
			return { ...state, list: { data: [] } };

		case 'GET_TRANSACTION_BY_USER_ID_SUCCESS': {
			const data = isArray(action.payload) && [...action.payload];
			return { ...state, list: { data, loading: false } };
		}
		case 'GET_CREDIT_BY_USER_ID_REQUEST':
			return { ...state, listCredits: { ...initialState.listCredits } };

		case 'GET_CREDIT_BY_USER_ID_SUCCESS': {
			if (action.payload.statusCode && action.payload.statusCode === 404) {
				return { ...state };
			}
			// const data = [...state.listCredits.data, ...action.payload];
			// return { ...state, listCredits: { data, loading: false } };
			return { ...state };
		}
		case 'FILTER_TRANSACTIONS_REQUEST':
			return { ...state, list: { ...initialState.list } };

		case 'FILTER_TRANSACTIONS_SUCCESS': {
			const data = [...state.list.data, ...action.payload];
			return { ...state, list: { data, loading: false } };
		}
		case 'GET_DAILY_TRANSACTIONS_BY_USER_ID_REQUEST':
			return { ...state, history: { ...initialState.history } };
		case 'GET_DAILY_TRANSACTIONS_BY_USER_ID_SUCCESS': {
			const data = { ...action.payload };
			return { ...state, history: { data, loading: false } };
		}
		case 'GET_RESTAURANT_REFUNDS_HISTORY_REQUEST':
			return { ...state, refundsHistory: { ...initialState.refundsHistory } };
		case 'GET_RESTAURANT_REFUNDS_HISTORY_SUCCESS': {
			const data = [...action.payload];
			return { ...state, refundsHistory: { data, loading: false } };
		}
		case 'GET_RESTAURANT_REFUNDS_HISTORY_DETAILS_REQUEST':
			return { ...state, refundsHistoryDetails: { ...initialState.refundsHistoryDetails } };
		case 'GET_RESTAURANT_REFUNDS_HISTORY_DETAILS_SUCCESS': {
			const data = [...action.payload];
			return { ...state, refundsHistoryDetails: { data, loading: false } };
		}
		case 'GET_RESTAURANT_REFUNDS_PDF_REQUEST':
			return { ...state };
		case 'GET_RESTAURANT_REFUNDS_PDF_SUCCESS': {
			return { ...state };
		}
		case 'GET_RESTAURANT_RETROCESSION_PDF_REQUEST':
			return { ...state };
		case 'GET_RESTAURANT_RETROCESSION_PDF_SUCCESS': {
			return { ...state };
		}
		default:
			return state;
	}
};
